module.exports = __webpack_public_path__ + "static/media/money_heist.14f8d371.jpg";